// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"Iauy6P2PIawVO54jBpGf","links":"pkH3BPfjl2sHQlCKeGQl","submit":"w2u8gLF2OzW9Nt7dE3Yr"};